const INITIAL_STATE = {
  data: {},
  errors: {},
            
}
const getSingleInvoice = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_INVOICE_VIEW_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_INVOICE_VIEW_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
            
export default getSingleInvoice;